const so = (s: string) => s.replace(/\D/g, '');

function digitoCpf(base: string, pesoInicial: number): number {
  const soma = [...base].reduce((s, d, i) => s + Number(d) * (pesoInicial - i), 0);
  const resto = (soma * 10) % 11;
  return resto === 10 ? 0 : resto;
}

function digitoCnpj(base: string): number {
  const pesos =
    base.length === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const soma = [...base].reduce((s, d, i) => s + Number(d) * pesos[i]!, 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function cpfValido(entrada: string): boolean {
  const d = so(entrada);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  return (
    digitoCpf(d.slice(0, 9), 10) === Number(d[9]) && digitoCpf(d.slice(0, 10), 11) === Number(d[10])
  );
}

export function cnpjValido(entrada: string): boolean {
  const d = so(entrada);
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  return (
    digitoCnpj(d.slice(0, 12)) === Number(d[12]) && digitoCnpj(d.slice(0, 13)) === Number(d[13])
  );
}

export function tipoDocumento(entrada: string): 'cpf' | 'cnpj' | null {
  if (cpfValido(entrada)) return 'cpf';
  if (cnpjValido(entrada)) return 'cnpj';
  return null;
}

export function formatarDocumento(entrada: string): string {
  const d = so(entrada);
  if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  return entrada;
}
